<div class="row mt-3" [formGroup]="form">
  <div class="col-md-12">
    <div class="card">

      <div class="float-start card-header card-header-detail" i18n>Biometriedaten</div>

      <div class="card-body">

        <div class="row">

          <div class="col-md-8">
            <div class="mb-3">
              <div [ngbPopover]="popover_antragsteller_biometrie_fingerabdrueckeErfassungsDatum_vorhanden">
                <app-pass-restricted-checkbox
                  [control]="form.controls.fingerabdrueckeBereitsErfasstAuswahl"
                  [title]="fingerabdrueckeTitleKey"
                  [labels]="fingerabdrueckeLabels"
                  [required]="true"
                  [selectedCheckbox$]="fingerabdrueckeBereitsErfasstSelected$">
                </app-pass-restricted-checkbox>
              </div>

              <ng-template #popover_antragsteller_biometrie_fingerabdrueckeErfassungsDatum_vorhanden>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>
                    Bitte wählen Sie hier aus, ob für den/die Antragstellende(n) bereits einmal Fingerabdrücke
                    für die Beantragung eines Schengenvisums erfasst wurden.
                  </span>
                </app-assistant>
              </ng-template>
            </div>
          </div>

          <div class="col-md-4" *ngIf="form.value.fingerabdrueckeBereitsErfasst === true">
            <div class="mb-3">
              <label for="antragsteller.biometrie.fingerabdrueckeErfassungsDatum" class="mandatory" i18n>
                Datum (TT.MM.JJJJ):
              </label>
              <input id="antragsteller.biometrie.fingerabdrueckeErfassungsDatum"
                     type="text" [attr.maxlength]="getMaxLength('fingerabdrueckeErfassungsDatum')"
                     appDynamicDateMaxLength
                     appResetDateSpecialValues
                     class="form-control form-control-sm"
                     [class.is-invalid]="form.controls['fingerabdrueckeErfassungsDatum'].invalid
                        && (form.controls['fingerabdrueckeErfassungsDatum'].touched || form.controls['fingerabdrueckeErfassungsDatum'].dirty)"

                     formControlName="fingerabdrueckeErfassungsDatum"
                     [ngbPopover]="popover_antragsteller_biometrie_fingerabdrueckeErfassungsDatum"
                     appSaveLastFocussed
                     appFixDate="past"
                     unknownReplacement="00"
              >
              <ng-template #popover_antragsteller_biometrie_fingerabdrueckeErfassungsDatum>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier das Datum der Erfassung der Fingerabdrücke (im Format TT.MM.JJJJ) ein. Wenn der genaue Tag nicht bekannt ist, so können Sie für den Tag hilfsweise 00 angeben. Das Jahr und der Monat sind jedoch zwingend erforderlich.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>

          <div class="fw-bold mt-1" style="color: rgb(202, 125, 125);" *ngIf="!isVidex() && fingerabdrueckeErfassungsDatumUiErrors?.olderThanMaxMonths" i18n>
            Die Fingerabdrücke wurden im Rahmen eines Schengen-Visums vor mehr als 59 Monaten erfasst und können daher nicht übernommen werden.
          </div>

        </div>

        <div class="row" *ngIf="appConfig.isZusaetzlicheAngabenActive !== true">
          <div class="col-md-4">
            <app-stickernummer formControlName="stickernummer"></app-stickernummer>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
